import { Flex, Stack, Text, useCheckboxState } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { CollapsibleCheckbox } from '../../../CollapsibleCheckbox'
import { IntegerInput } from '../../../IntegerInput'
import {
  RestrictionElementProps,
  RestrictionFieldProps,
} from '../hooks/useRestrictions.constate'
import { RestrictionsRegister } from './Component.register'
import styles from './styles.css'

export const MaxUsagePerClient = (props: RestrictionFieldProps) =>
  RestrictionsRegister({ Element: MaxUsagePerClientEditor, props })

const MIN_VALUE = 1

function MaxUsagePerClientEditor(props: RestrictionElementProps) {
  const { name, form } = props
  const { $t } = useIntl()

  const maxUsagePerClient: boolean = useWatch({
    form,
    name,
  })

  const handleChange = ({ target: { checked } }) => {
    if (!checked) {
      form.resetField(name)
      form.setValue(name, undefined)
    } else {
      form.setValue(name, MIN_VALUE)
    }
  }

  const state = useCheckboxState({
    initialValue: maxUsagePerClient !== undefined,
  })

  return (
    <Stack fluid space="$space-4">
      <CollapsibleCheckbox
        state={state}
        label={$t({
          id: 'admin/promotions.form.restrictions.max-usage-per-client',
        })}
        onChange={handleChange}
      >
        <Flex align="baseline">
          <div className={styles.inputContainer}>
            <IntegerInput
              name={name}
              state={form}
              min={MIN_VALUE}
              aria-label={$t({
                id: 'admin/promotions.form.restrictions.max-usage.input.aria-label',
              })}
            />
          </div>

          <Text tone="secondary">
            {$t(
              { id: 'admin/promotions.form.utils.times' },
              { value: maxUsagePerClient }
            )}
          </Text>
        </Flex>
      </CollapsibleCheckbox>
    </Stack>
  )
}
